// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './common/js/router'
import store from './common/js/store'
import axios from './common/js/http'
import VueJsonp from 'vue-jsonp'
import {C} from './common/js/common'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueAMap from 'vue-amap'
import VueKindEditor from 'vue-kindeditor'
import 'kindeditor/kindeditor-all.js'
import 'kindeditor/themes/default/default.css'
import Laypage from 'vue-laypage'
import 'vue-laypage/dist/vue-laypage.css'
// 引入vue-scrollwatch
import vueScrollwatch from 'vue-scrollwatch'
// 引入vue-awesome-swiper
import VueAwesomeSwiper from 'vue-awesome-swiper'
// require styles
import 'swiper/dist/css/swiper.css'
require('./common/js/filter')
// 正式环境
// require('./assets/js/vconsole')

Vue.use(VueAwesomeSwiper)
// jsonp
Vue.use(VueJsonp)
// 分页组件
Vue.use(Laypage)
// 高德地图
Vue.use(VueAMap)
VueAMap.initAMapApiLoader({
  key: 'f7a838c6d73b0a81e3559088d5fcd0ad',
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor'],
  // 默认高德 sdk 版本为 1.4.4
  v: '1.4.4',
  uiVersion: '1.0' // 版本号
})
Vue.use(ElementUI)
Vue.config.productionTip = false
/* eslint-disable no-new */
Vue.use(VueKindEditor)
// 监听滚动
Vue.use(vueScrollwatch)
Vue.prototype.axios = axios

/* eslint-disable no-new */
new Vue({
  el: '#app',
  axios,
  router,
  store,
  methods: C,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js